import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExpand: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconExpand"><Path d="M3.75 10.25V6.75C3.75 5.09315 5.09315 3.75 6.75 3.75H18.25C19.9069 3.75 21.25 5.09315 21.25 6.75V12.25C21.25 13.9069 19.9069 15.25 18.25 15.25H14.75M17.25 7.75V10.75M17.25 7.75H14.25M17.25 7.75L14 11M9.25 21.25H4.75C3.64543 21.25 2.75 20.3546 2.75 19.25V15.75C2.75 14.6454 3.64543 13.75 4.75 13.75H9.25C10.3546 13.75 11.25 14.6454 11.25 15.75V19.25C11.25 20.3546 10.3546 21.25 9.25 21.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconExpand;
